export const emptyMenuContext = {
    financialAssistanceUrl: null,
    insuranceUrl: null,
    insuranceConsentUrl: null,
    notificationCenterUrl: null,
    preVisitAllVisitsUrl: null,
    verifyOrLogout: null,
    notifyAboutInvalidOrMissingContactInfo: false,
    providerLogoUrl: "/",
};

export const emptyBillingMenuContext = {
    allBillsUrl: null,
    paymentHistoryUrl: null,
    statementHistoryUrl: null,
    visible: false,
};

export const emptyPaymentOptionsContext = {
    paymentPlanCta: null,
    paymentPlanUrl: null,
    payPartialUrl: null,
    payTotalUrl: null,
    visible: false,
    showSelectBillsToPay: false,
};
